import { styled, Box, Grid } from '@mui/material';
import { colors } from '../../../constants/colors';

export const ModalContainerStyled = styled(Box)(({ theme }) => ({
  position: 'absolute' as 'absolute',
  padding: 15,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'fit-content',
  height: 'fit-content',
  maxWidth: '70%',
  maxHeight: '60%',
  overflowY: 'auto',
  backgroundColor: colors.white,
  borderRadius: 5,
  boxShadow: '24',
  '@media (max-width: 768px)': {
    width: 'fit-content',
    height: 'fit-content'
  },
  '@media (max-width: 480px)': {
    width: 'fit-content',
    height: 'fit-content'
  }
}));

export const CustomGrid = styled(Grid)(({ theme }) => ({
  marginBottom: '5px'
}));
